import React from "react";

const Detail = () => {
    
    return (
        <div className="main">
            <div className="menu-details">
                <div className="menu-detail-bg">
                    <div id="1" className="menu-detail right">
                        <h3 className="menu-title">全身リフレッシュコース ９０分<br/>５，０００円(初回のみ<span className="red-font">３，０００円</span>)</h3>
                        <p className="menu-text">お顔と腹部以外、頭からつま先までまんべんなく流していきます。疲労回復にはもちろん、免疫力アップにおすすめです。</p>
                    </div>
                    <div id="2" className="menu-detail left">
                        <h3 className="menu-title">ヘッドドレナージュ ３０〜４０分<br/>
                            ２，５００円</h3>
                        <p className="menu-text">デコルテ（首筋〜胸元）から頭部全体を優しく包みながら包み込むように流します。プラチナブブのエッセンスを頭皮に塗り込むことにより、健やかな頭皮、さらにはリラックス効果が期待できます(プラチナ部部には、マイナス４０mVの電位があります)</p>
                    </div>
                    <div id="3" className="menu-detail right">
                        <h3 className="menu-title">フェイシャル① ３０〜４０分<br/>
                            ３，０００円</h3>
                        <p className="menu-text">デコルテからお顔全体をリンパに沿って流していきます。お顔をリズミカルにつまみながらほぐし、皮下リンパの活性化を促します。（ベッド上での施術になります）<br/>
                            プラチナブブの化粧水とエッセンスで仕上げますと、お肌がワントーン明るくなります。</p>
                            <div className="note">※フェイシャルをご希望の方は、予め化粧を取ったままでご来店いただくか、当店で洗顔をしていただくことをご了承ください。</div>
                    </div>
                    <div id="4" className="menu-detail left">
                        <h3 className="menu-title">フェイシャル② ８０分<br/>
                            ５，０００円</h3>
                        <p className="menu-text">デコルテとヘッドのリンパ節を開いた後、V-rollの中周波EMSエネルギーの心地よくマイルドな電波で皮膚の代謝向上を促します。
                            マスク環境や、職場でのストレスなどで凝り固まった表情筋をしっかりケアしていきます。同じく凝り固まっている僧帽筋や胸鎖乳頭筋(首)の凝りもほぐしていきます。</p>
                            <div className="note">※フェイシャルをご希望の方は、予め化粧を取ったままでご来店いただくか、当店で洗顔をしていただくことをご了承ください。</div>
                    </div>
                    <div id="5" className="menu-detail right">
                        <h3 className="menu-title">よもぎ蒸し<br/>
                            着替え等の時間を含め約１時間<br/>
                            ２，５００円</h3>
                        <p className="menu-text">汗は尿の６倍もの毒素を体外に放出します。冷え性が気になる方、デトックスに興味のある方は是非お試しください。
                            タオルも蒸される前後の水分補給もこちらで準備させていただきます。<br/>
                            よもぎを煮込むなど、準備の都合がありますので、<span className="red-font">ご予約もキャンセルも前日まで</span>にお願いします。</p>
                    </div>
                    <div id="6" className="menu-detail left">
                        <h3 className="menu-title">お得なコラボメニュー</h3>
                        <p className="menu-text">
                        １.全身コース ＋ フェイシャル①<br/>
                        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;約２時間　7，０００円<br className="m-resp"/><br/>
                        ２.全身コース ＋ フェイシャル②<br/>
                        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;約３時間　９，０００円<br className="m-resp"/><br/>
                        ３.全身コース ＋ よもぎ蒸し<br/>
                        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;約２．５時間　7，０００円<br className="m-resp"/><br/>
                        ４.全身コース ＋ フェイシャル① ＋ よもぎ蒸し<br/>
                        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;約３時間　９，０００円<br className="m-resp"/><br/>
                        ５.全身コース ＋ フェイシャル② ＋ よもぎ蒸し<br/>
                        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;約４時間　１１，０００円<br className="m-resp"/><br/>
                        </p>
                    </div>
                    <div className="video">
                    <iframe src="https://www.youtube.com/embed/B1lx6NUsGO8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Detail